/**
 * TechScroll.js
 * Place in: src/components/TechScroll.js
 *
 * Put your SVG files in: src/assets/icons/
 * Filenames expected (one per tool, lowercase, see TOOLS array below).
 */

import React from "react";

/* ── Software ── */
import ReactIcon from "../assets/icons/react.svg";
import NextIcon from "../assets/icons/nextjs.svg";
import TypeScriptIcon from "../assets/icons/typescript.svg";
import NodeIcon from "../assets/icons/nodejs.svg";
import DotnetIcon from "../assets/icons/dotnet.svg";
import PythonIcon from "../assets/icons/python.svg";
import PostgresIcon from "../assets/icons/postgresql.svg";
import MongoIcon from "../assets/icons/mongodb.svg";

/* ── Cyber ── */
import BurpIcon from "../assets/icons/burpsuite.svg";
import NmapIcon from "../assets/icons/nmap.svg";
import MetasploitIcon from "../assets/icons/metasploit.svg";
import WiresharkIcon from "../assets/icons/wireshark.svg";
import KaliIcon from "../assets/icons/kalilinux.svg";
import SplunkIcon from "../assets/icons/splunk.svg";
import ElkIcon from "../assets/icons/elastic.svg";
import OsintIcon from "../assets/icons/osint.svg";

/* ── DevOps ── */
import DockerIcon from "../assets/icons/docker.svg";
import K8sIcon from "../assets/icons/kubernetes.svg";
import GhActionsIcon from "../assets/icons/githubactions.svg";
import TerraformIcon from "../assets/icons/terraform.svg";
import AwsIcon from "../assets/icons/aws.svg";
import JenkinsIcon from "../assets/icons/jenkins.svg";
import LinuxIcon from "../assets/icons/linux.svg";
import BashIcon from "../assets/icons/bash.svg";

/* ── Tool definitions ── */
const TOOLS = [
  /* ── Software ── */
  { label: "React",          cat: "software", svg: ReactIcon,      color: "#61DAFB" },
  { label: "Next.js",        cat: "software", svg: NextIcon,       color: "#e2e8f0" },
  { label: "TypeScript",     cat: "software", svg: TypeScriptIcon, color: "#3178C6" },
  { label: "Node.js",        cat: "software", svg: NodeIcon,       color: "#6cc24a" },
  { label: "C# / .NET",      cat: "software", svg: DotnetIcon,     color: "#9b59f5" },
  { label: "Python",         cat: "software", svg: PythonIcon,     color: "#f7cc42" },
  { label: "PostgreSQL",     cat: "software", svg: PostgresIcon,   color: "#4169E1" },
  { label: "MongoDB",        cat: "software", svg: MongoIcon,      color: "#47A248" },

  /* ── Cyber ── */
  { label: "Burp Suite",  cat: "cyber", svg: BurpIcon,       color: "#f87171" },
  { label: "Nmap",        cat: "cyber", svg: NmapIcon,       color: "#22d3a5" },
  { label: "Metasploit",  cat: "cyber", svg: MetasploitIcon, color: "#f87171" },
  { label: "Wireshark",   cat: "cyber", svg: WiresharkIcon,  color: "#1679A7" },
  { label: "Kali Linux",  cat: "cyber", svg: KaliIcon,       color: "#557eff" },
  { label: "Splunk",      cat: "cyber", svg: SplunkIcon,     color: "#e9d35b" },
  { label: "ELK Stack",   cat: "cyber", svg: ElkIcon,        color: "#f04e98" },
  { label: "OSINT",       cat: "cyber", svg: OsintIcon,      color: "#22d3a5" },

  /* ── DevOps ── */
  { label: "Docker",         cat: "devops", svg: DockerIcon,     color: "#2496ED" },
  { label: "Kubernetes",     cat: "devops", svg: K8sIcon,        color: "#326CE5" },
  { label: "GitHub Actions", cat: "devops", svg: GhActionsIcon,  color: "#e2e8f0" },
  { label: "Terraform",      cat: "devops", svg: TerraformIcon,  color: "#7B42BC" },
  { label: "AWS",            cat: "devops", svg: AwsIcon,        color: "#FF9900" },
  { label: "Jenkins",        cat: "devops", svg: JenkinsIcon,    color: "#D33833" },
  { label: "Linux",          cat: "devops", svg: LinuxIcon,      color: "#FCC624" },
  { label: "Bash",           cat: "devops", svg: BashIcon,       color: "#22d3a5" },
];

/* ── Component ── */
export default function TechScroll({ activeRole = "all" }) {
  const filtered =
    activeRole === "all"
      ? TOOLS
      : TOOLS.filter((t) => t.cat === activeRole);

  const repeated = filtered.length
    ? [...filtered, ...filtered, ...filtered]
    : [];

  return (
    <div className="tech-scroll-wrap">
      <p className="tech-scroll-label">Tech Stack</p>

      {repeated.length === 0 ? (
        <p style={{ color: "#475569", fontFamily: "var(--font-mono)", fontSize: "0.8rem", textAlign: "center" }}>
          No tools in this category.
        </p>
      ) : (
        <div className="scroll-track">
          <div className="scroll-inner">
            {repeated.map(({ label, cat, svg, color }, i) => (
              <span
                key={i}
                className={`tech-pill cat-${cat}`}
                style={{ "--pill-color": color }}
              >
                {/* Diamond marker instead of dot */}
                

                <img
                  src={svg}
                  alt={label}
                  className="tech-icon"
                  width={16}
                  height={16}
                  style={{ flexShrink: 0 }}
                />
                {label}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


